/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { EmbersTypography } from '../../typography';
import { EmbersGrid } from '../../grid';
import { StyledColumnSectionGroup, StyledColumnSection } from './styles';
export var Columns = function Columns(_ref) {
  var _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data;
  return /*#__PURE__*/React.createElement(StyledColumnSectionGroup, {
    className: "EmbersTemplate-marketingColumns-root",
    count: data.length
  }, /*#__PURE__*/React.createElement(EmbersGrid, {
    container: true,
    spacing: 6,
    columnSpacing: {
      xs: 0,
      sm: 0,
      md: 6,
      lg: 6,
      xl: 6
    },
    alignItems: "flex-start"
  }, data.map(function (v, i) {
    return /*#__PURE__*/React.createElement(StyledColumnSection, {
      key: i,
      item: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "EmbersTemplate-marketingColumns-circle",
      style: {
        background: v.color
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "icon-".concat(v.iconName)
    })), /*#__PURE__*/React.createElement(EmbersTypography, {
      className: "EmbersTemplate-marketingColumns-title",
      variant: "h5",
      componentType: "h2",
      marginTop: 2,
      marginBottom: 1
    }, v.title), /*#__PURE__*/React.createElement(EmbersTypography, {
      variant: "body",
      margin: 0
    }, v.description));
  })));
};